/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {KitchenDramaSushiManiaGameMode} from "../server/KitchenDramaSushiManiaGameMode";
import {LoopableList} from "../utils/LoopableList";
import {WinSize} from "../view/KitchenDramaSushiManiaWinView";

export class KitchenDramaSushiManiaSound {

    public static REELS_SPINNING:string = "reelsSpinning";
    public static REELS_LANDING:string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];
    public static MAIN_GAME_MUSIC:string = "background-music-main";
    public static WILD_SUSHI_MUSIC:string = "background-music-japan";

    private _currentMusic:string;

    private player:NolimitAudioPlayer;

    static AS_WIN:string = "asWin";
    static AS_WIN_BIG:string = "asWinBig";

    static CONTINUE_BUTTON:string = "continueButton";
    private static COUNT_END_SOUND:string = "countup-ends";
    private static COUNT_SMALL:string = "countup-small";
    public static COUNT_MEDIUM:string = "countup-medium";
    private static COUNT_LARGE:string = "countup-large";
    static WILD_SUSHI_TEXT_SOUND:string = "fs-splash-sword";
    static COLLECT_FREESPIN_SYMBOL:string = "collected-freespin-symbol";
    static COLLECT_KA:string = "collected-kamisabi-top";
    static COLLECT_MI:string = "collected-kamisabi-middle";
    static COLLECT_SABI:string = "collected-kamisabi-bottom";

    static JUMP_LOW:string = "low-win-characters-jumping";
    static JUMP_MID_1:string = "high-win-characters-jumping-one";
    static JUMP_MID_2:string = "high-win-characters-jumping-two";
    static JUMP_MID:LoopableList<string> = new LoopableList<string>([
        KitchenDramaSushiManiaSound.JUMP_MID_1,
        KitchenDramaSushiManiaSound.JUMP_MID_2
    ]);



    static MEDIUM_WIN_CHARACTERS_SLICE_ONE:string = "high-win-characters-slice-one";
    static MEDIUM_WIN_CHARACTERS_SLICE_TWO:string = "high-win-characters-slice-two";
    static MEDIUM_WIN_CHARACTERS_SLICE_THREE:string = "high-win-characters-slice-three";
    static MEDIUM_WIN_CHARACTERS_SLICE_FOUR:string = "high-win-characters-slice-four";
    static MEDIUM_SLICE_SOUNDS:LoopableList<string> = new LoopableList<string>([
        KitchenDramaSushiManiaSound.MEDIUM_WIN_CHARACTERS_SLICE_ONE,
        KitchenDramaSushiManiaSound.MEDIUM_WIN_CHARACTERS_SLICE_TWO,
        KitchenDramaSushiManiaSound.MEDIUM_WIN_CHARACTERS_SLICE_THREE,
        KitchenDramaSushiManiaSound.MEDIUM_WIN_CHARACTERS_SLICE_FOUR,
    ]).setRandomizeAtWrapAround(true);

    static LOW_WIN_CHARACTERS_SLICE_ONE:string = "low-win-characters-slice-one";
    static LOW_WIN_CHARACTERS_SLICE_TWO:string = "low-win-characters-slice-two";
    static LOW_WIN_CHARACTERS_SLICE_THREE:string = "low-win-characters-slice-three";
    static LOW_WIN_CHARACTERS_SLICE_FOUR:string = "low-win-characters-slice-four";
    static LOW_SLICE_SOUNDS:LoopableList<string> = new LoopableList<string>([
        KitchenDramaSushiManiaSound.LOW_WIN_CHARACTERS_SLICE_ONE,
        KitchenDramaSushiManiaSound.LOW_WIN_CHARACTERS_SLICE_TWO,
        KitchenDramaSushiManiaSound.LOW_WIN_CHARACTERS_SLICE_THREE,
        KitchenDramaSushiManiaSound.LOW_WIN_CHARACTERS_SLICE_FOUR,
    ]).setRandomizeAtWrapAround(true);


    static SYMBOL_LANDING:string = "symbol-landing";
    static SYMBOLS_LANDING:string = "symbols-landing";

    static LOW_WIN_CHARACTERS_FALLING_DOWN:string = "low-win-characters-falling-down";
    static MEDIUM_WIN_CHARACTERS_FALLING_DOWN:string = "high-win-characters-falling-down";


    static WILD_JUMP_ONE:string = "wild-jump-one";
    static WILD_JUMP_TWO:string = "wild-jump-two";
    static WILD_JUMP:LoopableList<string> = new LoopableList<string>([
        KitchenDramaSushiManiaSound.WILD_JUMP_ONE,
        KitchenDramaSushiManiaSound.WILD_JUMP_TWO
    ]);
    static WILD_LANDING:string = "wild-landing";
    static WILD_SPLIT:string = "wild-split";

    static KAMISABI_KA:string = "kamisabi-splash-ka";
    static KAMISABI_MI:string = "kamisabi-splash-mi";
    static KAMISABI_SABI:string = "kamisabi-splash-sabi";

    static KAMISABI_MELT_MID_WINS:string = "kamisabi-melting";
    static KAMISABI_MELT_LOW_SYMS:string = "kamisabi-melting-low-syms";
    static KAMISABI_SPLAT:string = "kamisabi-splat";
    static KAMISABI_TAKEOFF:string = "kamisabi-takeoff";
    static KAMISABI_FALLING:string = "kamisabi-falling";
    static KAMISABI_SPLASH:string = "kamisabi-splash";

    static BLOB_SUCK:string = "blob-sucking";

    static WIN_SMALL:string = "win-small";
    static WIN_MEDIUM:string = "win-medium";
    static WIN_LARGE:string = "win-large";

    static BIG_WIN_SMALL:string = "big-win-small";
    static BIG_WIN_MEDIUM:string = "big-win-medium";
    static BIG_WIN_LARGE:string = "big-win-large";
    static BIG_WIN_ENDS:string = "big-win-ends";


    static TURN_INTO_WILD_SUSHI:string = "fs-turn-into-wild";
    static WILD_ATTENTION:string = "wild";

    static FS_END_SOUND:string = "fs-ends";
    static FS_SPLASH_MELODY:string = "fs-splash-melody";
    static FS_SPLASH_NUMBER:string = "fs-splash-number";
    static FS_SPLASH_START:string = "fs-splash-start";
    static FS_SPLASH_START_MELODY:string = "fs-splash-start-melody";
    static FS_SPLASH_SWORD:string = "fs-splash-sword";

    static FS_METER_REACH_BAR:string = "fs-meter-reach-bar";
    static FS_METER_TURN_INTO_WILD:string = "fs-meter-turn-into-wild";
    static FS_METER_UP:string = "fs-meter-up";

    constructor() {
        this.player = <NolimitAudioPlayer>SlotGame.sound
    }

    private static createConfig(name:string, volume?:number, repeat?:number) {
        return {
            name:name,
            volume:volume,
            repeat:repeat
        }
    }

    public playSound(name:string, volume?:number, repeat?:number) {
        this.player.playTrack(KitchenDramaSushiManiaSound.createConfig(name, volume, repeat));
    }

    public stopSound(name:string) {
        this.player.stopTrack(name);
    }

    public fadeOutMusic(duration:number = 300, targetVolume:number = 0) {
        if(this._currentMusic) {
            this.player.fadeTrack({
                name : this._currentMusic,
                to : targetVolume,
                duration : duration
            });
        }
    }

    public fadeInMusic(duration:number = 300) {
        if(this._currentMusic) {
            this.player.fadeTrack({
                name : this._currentMusic,
                to : 1,
                duration : duration
            });
        }
    }

    public switchMusic(mode:GameMode | string, volume:number = 1) {
        let nextMusic = "";

        switch (mode) {
            case KitchenDramaSushiManiaGameMode.WILD_SUSHI:
                nextMusic = KitchenDramaSushiManiaSound.WILD_SUSHI_MUSIC;
                break;
            default:
                nextMusic = KitchenDramaSushiManiaSound.MAIN_GAME_MUSIC;
                break;
        }

        if (nextMusic == this._currentMusic) {
            return;
        }

        if (this._currentMusic) {
            this.player.stopTrack(this._currentMusic);
        }

        this.player.playTrack(KitchenDramaSushiManiaSound.createConfig(nextMusic, volume, undefined));
        this._currentMusic = nextMusic;
    }

    playWinSound(size:WinSize) {
        let winSoundName = "";
        if (size == WinSize.tiny){
            winSoundName = KitchenDramaSushiManiaSound.WIN_SMALL;
        }
        else if (size == WinSize.small){
            winSoundName = KitchenDramaSushiManiaSound.WIN_SMALL;
        }
        else if (size == WinSize.medium){
            winSoundName = KitchenDramaSushiManiaSound.WIN_MEDIUM;
        }
        else if (size == WinSize.large){
            winSoundName = KitchenDramaSushiManiaSound.WIN_LARGE;
        }
        else if (size == WinSize.big){
            winSoundName = KitchenDramaSushiManiaSound.BIG_WIN_SMALL;
        }
        else if (size == WinSize.mega){
            winSoundName = KitchenDramaSushiManiaSound.BIG_WIN_MEDIUM;
        }
        else if (size == WinSize.superMega){
            winSoundName = KitchenDramaSushiManiaSound.BIG_WIN_LARGE;
        }

        this.playSound(winSoundName);
        //this.playSound(KitchenDramaSushiManiaSound.COUNT_SMALL);
    }

    endCountUp() {
        this.playSound(KitchenDramaSushiManiaSound.COUNT_END_SOUND);

    }

}